module.exports = "<p>\r\n  update-menu works!\r\n</p>\r\n"